export default ({ plurals = [], count }) => {
    const dividedNumber = count / 10
    const simpleNumber = (dividedNumber - parseInt(dividedNumber)) * 10;
    if (simpleNumber === 1) return plurals[0];
    if ([2, 3, 4].includes(simpleNumber)) return plurals[1];
    console.log(simpleNumber)
    return plurals[2];
}